var _circle, _path, _path2, _circle2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 249.864,
    cy: 137.208,
    r: 73.7081,
    fill: "#F0FFF1",
    stroke: "#231942",
    strokeWidth: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9844 375.261L123.228 246.512H374.195L422.319 375.191V401.694H72.9844V375.261Z",
    fill: "#F0FFF1",
    stroke: "#231942",
    strokeWidth: 19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.317 409.026L128.186 281.852H367.431L349.263 409.026H142.317Z",
    fill: "#F0FFF1",
    stroke: "#231942",
    strokeWidth: 5.70334
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.65,
    cy: 344.626,
    r: 23.2983,
    fill: "#231942"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 407.865,
    width: 463.746,
    height: 35.5021,
    rx: 9,
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIconWhite);
export default __webpack_public_path__ + "static/media/employee_icon_white.b3e48e49bd5fd0e662a6228cc8647c98.svg";
export { ForwardRef as ReactComponent };